import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';
import '../../common/bn-flash';

class AddBinModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'add-bin-modal';
  }

  static get properties() {
    return {
      actionHref: { type: String, attribute: false },
      binsHref: { type: String, attribute: false },
    };
  }

  renderContents() {
    return html`
      <style>
        bn-modal#add-bin-modal {
          --modal-min-width: 55%;
          --modal-max-width: 25%;
        }
        organization-ancestors-bread-crumbs {
          display: inline;
        }
        .adding-into {
          margin-top: 0.75em;
          display: flex;
          margin-bottom: 1em;
          opacity: .7;
        }
        h3 {
          margin: 0;
        }
      </style>

      <h3 slot="title">Add Bin</h3>
      <bn-flash id="status"></bn-flash>

      <div class='adding-into'>
        Adding Bin into:&nbsp;
        <organization-ancestors-bread-crumbs .href="${this.href}" linkPath="" ancestorMinIndex="0">
        </organization-ancestors-bread-crumbs>
      </div>

      <bn-action
        .href="${this.binsHref}"
        actionname="add-bin"
        @response="${this._onResponse}"
        @error="${this._onError}"
        suppressflash
      >
        <span slot="header"></span>
      </bn-action>
    `;
  }

  _onResponse(e) {
    const { entity } = e.detail;
    const binId = entity.getLinkByRel('self').href;
    const binName = entity.properties.name;
    const flash = this.renderRoot.querySelector('#status');
    flash.success(html`Bin "${binName}" Created: <a href="/bins/show/overview?binId=${encodeURIComponent(binId)}">View Bin</a>`);
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail, bubbles: true, composed: true }));
  }

  _onError(e) {
    const { message } = e.error;
    const flash = this.renderRoot.querySelector('#status');

    flash.clear();
    flash.critical(html`
      Bin Creation Failed
      <br/>
      <code>${message}</code>
    `);
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }
}

window.customElements.define('add-bin-modal', AddBinModal);
